import Action, { GetContext, } from './Action';
const TriggerFlowName = Symbol('flowName');
export default class Trigger extends Action {
    constructor(triggerFlowName) {
        if (typeof triggerFlowName !== 'string' || !triggerFlowName.length) {
            throw new TypeError('Trigger constructor expects a non-empty string as its constructor argument');
        }
        super();
        this[TriggerFlowName] = triggerFlowName;
        this[GetContext] =
            () => ({ triggerFlowName });
    }
    get flowName() {
        return this[TriggerFlowName];
    }
}
